// Import model
import { FilterContentResultRequest } from '../models/FilterContentResultRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContentResultCondition } from '../models/ContentResultCondition';
import { ContentResultFields } from '../models/ContentResultFields';
import { ContentResultIndexedFields } from '../models/ContentResultIndexedFields';

// Import dependency serializers (for complex types)
import { ContentResultConditionSerializer } from './ContentResultConditionSerializer';
import { ContentResultFieldsSerializer } from './ContentResultFieldsSerializer';
import { ContentResultIndexedFieldsSerializer } from './ContentResultIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterContentResultRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterContentResultRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterContentResultRequest instance
   */
  static deserialize(json: string): FilterContentResultRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterContentResultRequest instance
   */
  static fromObject(obj: any): FilterContentResultRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterContentResultRequest');
    }


    const instance: FilterContentResultRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ContentResultIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ContentResultFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ContentResultConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterContentResultRequest instances
   */
  static deserializeArray(json: string): FilterContentResultRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterContentResultRequest instance to a JSON string
   */
  static serialize(instance: FilterContentResultRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterContentResultRequest instance to a plain object
   */
  static toObject(instance: FilterContentResultRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ContentResultConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterContentResultRequest instances to a JSON string
   */
  static serializeArray(instances: FilterContentResultRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
